var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTourHomeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19824 11.792L3.42046 9.56977M3.42046 9.56977L11.1982 1.79199L18.976 9.56977M3.42046 9.56977V20.6809C3.42046 20.9756 3.53753 21.2582 3.7459 21.4666C3.95428 21.6749 4.23689 21.792 4.53158 21.792H7.86491M18.976 9.56977L21.1982 11.792M18.976 9.56977V20.6809C18.976 20.9756 18.859 21.2582 18.6506 21.4666C18.4422 21.6749 18.1596 21.792 17.8649 21.792H14.5316M7.86491 21.792C8.15959 21.792 8.44221 21.6749 8.65058 21.4666C8.85896 21.2582 8.97602 20.9756 8.97602 20.6809V16.2364C8.97602 15.9418 9.09308 15.6591 9.30146 15.4508C9.50983 15.2424 9.79245 15.1253 10.0871 15.1253H12.3094C12.604 15.1253 12.8867 15.2424 13.095 15.4508C13.3034 15.6591 13.4205 15.9418 13.4205 16.2364V20.6809C13.4205 20.9756 13.5375 21.2582 13.7459 21.4666C13.9543 21.6749 14.2369 21.792 14.5316 21.792M7.86491 21.792H14.5316",
    stroke: "#171A21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourHomeIcon);
export default __webpack_public_path__ + "static/media/tour-home-icon.7bdf56cbf5a882c618136887b4c9bb9b.svg";
export { ForwardRef as ReactComponent };